import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { DEV } from '../../../../constants/constants'
import { pageList } from '../../../../utils/pageList';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';


export const allSwitchedRoutes = () => {
  const pagesKeys = Object.keys(pageList);
  return (
    <Switch>
      {pagesKeys.map((pageKey) => {
        const currentPage = pageList[pageKey];
        const {
          id,
          hash,
          component,
          exact,
          to,
          onlyDev,
        } = currentPage;
        let allowToShow = true;
        if (onlyDev) {
          const { NODE_ENV } = process.env;
          allowToShow = NODE_ENV === DEV;
        }
        if (component && allowToShow) {
          return <Route exact={exact} key={`route${id}`} path={`${hash}`} component={component} />
        }
        if (!component && to) {
          return <Route key={`redirect${id}`} exact={exact} path={`${hash}`} render={() => (<Redirect to={to} />)} />
        }
        return null;
      })}
    </Switch>
  )
}

class Routes extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
  }

  render() {
    const {
      history,
    } = this.props;
    return (
      <ErrorBoundary history={history}>
        { allSwitchedRoutes() }
      </ErrorBoundary>
    )
  }
}

export default Routes;
